import { ref, onMounted, onBeforeUnmount, onBeforeMount } from 'vue'
import { useStore } from '@/stores/main'
import shortUUID from 'short-uuid'
import { debounce } from 'debounce'

const scrollY = ref(0)
const scrollX = ref(0)
const scrollProgress = ref(0)
const heroAnimationComplete = ref(false)

export default function useUtils() {
  const device = ref()
  let cleanupMediaListeners = () => {}
  const updateScrollPosition = () => {
    scrollY.value = window.scrollY || window.pageYOffset || 0
    scrollX.value = window.scrollX || window.pageXOffset || 0
  }

  const updateDevice = () => {
    const viewportWidth = window.visualViewport?.width || window.innerWidth
    device.value = isDevice(viewportWidth)
  }
  const debouncedResizeHandler = debounce(updateDevice, 150)

  const genUUID = () => {
    return shortUUID('0123456789abcdefghijklmnoqrstuvwxyz')
      .generate()
      .substring(0, 10)
  }

  const decodeTitle = (title) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = title
    return txt.value
  }

  const convertToRelative = (url) => {
    const store = useStore()
    const path = url.replace(store.site.url, '')
    return path
  }

  const isExternal = (url) => {
    const domain = (url) => {
      return url.replace('http://', '').replace('https://', '').split('/')[0]
    }
    return domain(location.href) !== domain(url)
  }

  const isDevice = (val) => {
    if (val < 768) {
      return (device.value = 'mobile')
    } else if (val >= 768 && val < 1024) {
      return (device.value = 'tablet')
    } else if (val >= 1024) {
      return (device.value = 'desktop')
    }
  }

  const setScrollProgress = (progress) => {
    scrollProgress.value = progress
  }

  const sizing = () => {
    window.addEventListener('resize', debouncedResizeHandler)
    window.addEventListener('orientationchange', updateDevice)

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', debouncedResizeHandler)
    }

    const mediaQueries = [
      window.matchMedia('(max-width: 767px)'),
      window.matchMedia('(min-width: 768px) and (max-width: 1023px)'),
      window.matchMedia('(min-width: 1024px)'),
    ]

    mediaQueries.forEach((mediaQuery) => {
      mediaQuery.addEventListener('change', updateDevice)
    })

    cleanupMediaListeners = () => {
      mediaQueries.forEach((mediaQuery) => {
        mediaQuery.removeEventListener('change', updateDevice)
      })
    }

    updateDevice()
  }

  onMounted(() => {
    window.addEventListener('scroll', updateScrollPosition, { passive: true })
    updateScrollPosition()
  })

  onBeforeMount(() => {
    sizing()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', debouncedResizeHandler)
    window.removeEventListener('orientationchange', updateDevice)

    if (window.visualViewport) {
      window.visualViewport.removeEventListener(
        'resize',
        debouncedResizeHandler
      )
    }

    window.removeEventListener('scroll', updateScrollPosition)

    cleanupMediaListeners()
  })

  return {
    device,
    scrollY,
    heroAnimationComplete,
    scroll,
    decodeTitle,
    convertToRelative,
    isExternal,
    setScrollProgress,
    genUUID,
  }
}
